/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  itemRubricPanelContainer: css`
    background-color: var(--cds-color-neutral-background-primary);
    width: 100%;
    overflow: auto;
    flex-grow: 1;
  `,
};

type Props = {
  children?: React.ReactNode;
};

const RightPanel = ({ children }: Props) => {
  return (
    <div css={styles.itemRubricPanelContainer} data-testid="right-panel-parent-container">
      {children}
    </div>
  );
};

export default RightPanel;
